import { z } from 'zod'

// 공통 스키마들
export const nodeEnvSchema = z.enum(['development', 'production', 'test'])
export const appEnvSchema = z.enum(['local', 'development', 'staging', 'production', 'temp', 'qa'])

export const productionAppEnvSchema = appEnvSchema.extract([appEnvSchema.enum.production])

const stringBooleanSchema = z.preprocess((value) => {
  if (typeof value !== 'string') {
    return value
  }
  if (value.toLowerCase() === 'true') {
    return true
  }
  if (value.toLowerCase() === 'false') {
    return false
  }
  return value
}, z.boolean())

// 공통 환경 변수 스키마들
export const commonServerSchema = {
  // 환경 설정
  APP_ENV: appEnvSchema,
  PUBLIC_API_URL: z.string().url(),

  // Redis (GCP Memorystore)
  REDIS_HOST: z.string().min(1),
  REDIS_PORT: z.coerce.number(),
  REDIS_TLS: stringBooleanSchema.optional().default(false),
  REDIS_AUTH_MODE: z.enum(['none', 'iam']).optional().default('none'),
  REDIS_CA_CERT_PATH: z.string().min(1).optional(),

  // Podo URLs
  PODO_API_URL: z.string().url(),
  PODO_ADMIN_URL: z.string().url(),
  PODO_WEB_URL: z.string().url(),
  PODOLINGO_WEB_URL: z.string().url(),
  PODOLINGO_API_URL: z.string().url(),

  // 외부 서비스 인증
  KAKAO_CLIENT_ID: z.string(),

  // Apple
  APPLE_APP_ID: z.string(),
  APPLE_SERVICE_ID: z.string(),
  APPLE_OAUTH_KEY: z.string(),
  APPLE_KEY_ID: z.string(),
  APPLE_TEAM_ID: z.string(),
} as const

export const commonClientSchema = {
  // 환경 설정
  NEXT_PUBLIC_APP_ENV: appEnvSchema,
  NEXT_PUBLIC_API_URL: z.string().url(),
  NEXT_PUBLIC_PODO_API_URL: z.string().url(),
} as const

export const commonSharedSchema = {
  NODE_ENV: nodeEnvSchema,
} as const

// 타입 추론을 위한 헬퍼 타입들
export type NodeEnv = z.infer<typeof nodeEnvSchema>
export type AppEnv = z.infer<typeof appEnvSchema>
export type CommonServerEnv = {
  [K in keyof typeof commonServerSchema]: z.infer<(typeof commonServerSchema)[K]>
}
export type CommonClientEnv = {
  [K in keyof typeof commonClientSchema]: z.infer<(typeof commonClientSchema)[K]>
}
export type CommonSharedEnv = {
  [K in keyof typeof commonSharedSchema]: z.infer<(typeof commonSharedSchema)[K]>
}
